/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_in_stock = /** @type {(inputs: {}) => string} */ () => {
	return `Na skladě`
};

const da_in_stock = /** @type {(inputs: {}) => string} */ () => {
	return `På lager`
};

const de_in_stock = /** @type {(inputs: {}) => string} */ () => {
	return `Auf Lager`
};

const en_in_stock = /** @type {(inputs: {}) => string} */ () => {
	return `In stock`
};

const es_in_stock = /** @type {(inputs: {}) => string} */ () => {
	return `En stock`
};

const fr_in_stock = /** @type {(inputs: {}) => string} */ () => {
	return `En stock`
};

const hu_in_stock = /** @type {(inputs: {}) => string} */ () => {
	return `Raktáron`
};

const it_in_stock = /** @type {(inputs: {}) => string} */ () => {
	return `Disponibile`
};

const nl_in_stock = /** @type {(inputs: {}) => string} */ () => {
	return `Op voorraad`
};

const pl_in_stock = /** @type {(inputs: {}) => string} */ () => {
	return `W magazynie`
};

const pt_in_stock = /** @type {(inputs: {}) => string} */ () => {
	return `Em estoque`
};

const sv_in_stock = /** @type {(inputs: {}) => string} */ () => {
	return `I lager`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const in_stock = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.in_stock(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("in_stock", locale)
	if (locale === "cs") return cs_in_stock(inputs)
	if (locale === "da") return da_in_stock(inputs)
	if (locale === "de") return de_in_stock(inputs)
	if (locale === "en") return en_in_stock(inputs)
	if (locale === "es") return es_in_stock(inputs)
	if (locale === "fr") return fr_in_stock(inputs)
	if (locale === "hu") return hu_in_stock(inputs)
	if (locale === "it") return it_in_stock(inputs)
	if (locale === "nl") return nl_in_stock(inputs)
	if (locale === "pl") return pl_in_stock(inputs)
	if (locale === "pt") return pt_in_stock(inputs)
	return sv_in_stock(inputs)
};